import { Trophy } from "grommet-icons";

export const digitalCourses = [
  {
    id: 1,
    title: "HPE Digital Learner Gold",
    icon: Trophy, // Directly reference the icon component
    color: "#d4af37",
  },
  {
    id: 2,
    title: "HPE Digital Learner Silver",
    icon: Trophy, // Directly reference the icon component
    color: "#c0c0c0",
  },
  {
    id: 3,
    title: "HPE Digital Learner Bronze",
    icon: Trophy, // Directly reference the icon component
    color: "#9f7a34",
  },
];
